export { default as FireBellyBackground } from './firebelly-bg.webp';
export { default as FireBellyLogo } from './firebelly-logo.webp';
